import { render, staticRenderFns } from "./UserFollowsModal.vue?vue&type=template&id=42c47c88&scoped=true&"
import script from "./UserFollowsModal.vue?vue&type=script&lang=js&"
export * from "./UserFollowsModal.vue?vue&type=script&lang=js&"
import style0 from "./UserFollowsModal.vue?vue&type=style&index=0&id=42c47c88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c47c88",
  null
  
)

export default component.exports